export const TERMS_OF_USE = {
	TITLE: 'Terms of Use',
	SUBHEADING:
		'By using Brand360, you agree to the following terms and conditions:',
	ERROR_TITLE: 'Unable to Accept Terms of Use',
	ERROR_MESSAGE:
		'Please try again in a few minutes. If the issue continues, please reach out to your Account Executive.',
};
